import * as THREE from 'three'

export const drawTableCircle = (
  centerPos,
  color,
  radius,
  group,
  opacity = 1,
  sceneMeshes
) => {
  const geometry = new THREE.CircleGeometry(radius, 32, 0, 2 * Math.PI)

  const obj = new THREE.Mesh(
    geometry,
    new THREE.MeshBasicMaterial({ color, opacity, transparent: true })
  )

  obj.position.set(centerPos.x, centerPos.y, centerPos.z)

  const triangle = new THREE.Group()
  triangle.add(obj)
  triangle.obj = obj
  sceneMeshes.push(triangle)

  if (group.renderOrder) {
    triangle.renderOrder = 2
  }

  return [triangle]
}
